/* jQuery */

const EMO = (function ($) {
  function EMO () {}

  EMO.storedFocus = null

  EMO.prototype.init = function () {
    const emo = this
    const $emos = $('[data-emo]')

    // Collect all the emos on the page, find and bind their close buttons
    $emos.each(function () {
      const $currentEmo = $(this)
      const $closeControl = $(`[data-emo-close="${$(this).data('emo')}"]`)
      $(this).attr('data-emo-open', false)

      $closeControl.click(function (e) {
        e.preventDefault()
        emo.toggle($currentEmo)
      })
    })

    emo.initEMOLinks()
    emo.initEMOCloseButtons()
  }

  EMO.prototype.initEMOLinks = function () {
    const emo = this
    emo.$emoLinks = $('a[href^="#emo-open-"]')

    emo.$emoLinks.each(function () {
      const $emoLink = $(this)
      const href = $emoLink.attr('href')
      const slug = href.replace('#emo-open-', '')

      $emoLink.click(function (e) {
        e.preventDefault()
        emo.storedFocus = $(':focus')
        const $emo = $(`[data-emo="${slug}"]`)
        emo.toggle($emo)
      })
    })
  }

  EMO.prototype.initEMOCloseButtons = function () {
    const emo = this
    emo.$emoCloseButtons = $('[data-emo-close="*"]')

    emo.$emoCloseButtons.each(function () {
      const $closeButton = $(this)
      $closeButton.click(function (e) {
        e.preventDefault()
        emo.closeAll()
      })
    })

    $(document).on('keydown', function (event) {
      if (event.key === 'Escape') {
        emo.closeAll()
      }
    })
  }

  EMO.prototype.emoKeyListener = function (event, firstFocusable, lastFocusable) {
    const isTabPressed = event.key === 'Tab' || event.keyCode === 9

    if (!isTabPressed) {
      return
    }

    if (event.shiftKey) { // if shift key pressed for shift + tab combination
      if ($(':focus')[0] === firstFocusable[0]) {
        lastFocusable.focus() // add focus for the last focusable element
        event.preventDefault()
      }
    } else { // if tab key is pressed
      if ($(':focus')[0] === lastFocusable[0]) { // if focused has reached to last focusable element then focus first focusable element after pressing tab
        firstFocusable.focus() // add focus for the first focusable element
        event.preventDefault()
      }
    }
  }

  EMO.prototype.focus = function (modalID) {
    const emo = this
    const focusableElements =
        'button, [href]:not(link), input, select, textarea, [tabindex]:not([tabindex="-1"])'
    const $modal = $('[data-emo="' + modalID + '"]') // select the modal by it's id

    const focusableContent = $modal.find(focusableElements)
    const firstFocusableElement = focusableContent.first() // get first element to be focused inside modal
    const lastFocusableElement = focusableContent.last() // get last element to be focused inside modal

    document.addEventListener('keydown', function (e) { emo.emoKeyListener(e, firstFocusableElement, lastFocusableElement) })

    firstFocusableElement.focus()
  }

  EMO.prototype.clearFocus = function () {
    const emo = this
    // document.removeEventListener('keydown', emo.emoKeyListener) // remove the focus listener

    // Return to previously focused element
    emo.storedFocus.focus()
  }

  EMO.prototype.toggle = function (_emo) {
    const emo = this
    const $emo = (_emo)

    // Closing EMO
    if ($emo.hasClass('emo--open')) {
      emo.close($emo)
    } else {
      // Opening EMO
      emo.open($emo)
    }
  }

  EMO.prototype.openEvent = new CustomEvent('emoOpen', {
    detail: {
      message: 'An EMO modal has opened.',
    },
    bubbles: true,
    cancelable: true
  });

  EMO.prototype.open = function (_emo) {
    const emo = this

    _emo.removeClass('emo--close')
    _emo.addClass('emo--open')
    _emo.attr('data-emo-open', true)

    emo.focus(_emo.data('emo'))
    if ($(document).height() > $(window).height()) {
      const scrollTop = ($('html').scrollTop()) ? $('html').scrollTop() : $('body').scrollTop()
      $('html').addClass('emo__noscroll').css('top', -scrollTop)
    }

    _emo[0].dispatchEvent(emo.openEvent)
  }

  EMO.prototype.close = function (_emo) {
    const emo = this

    _emo.removeClass('emo--open')
    _emo.addClass('emo--close')
    _emo.attr('data-emo-open', false)

    emo.clearFocus()
    const scrollTop = parseInt($('html').css('top'))
    $('html').removeClass('emo__noscroll')
    $('html,body').scrollTop(-scrollTop)
  }

  EMO.prototype.closeAll = function () {
    const emo = this
    const $emos = $('[data-emo]')

    $emos.each(function () {
      emo.close($(this))
    })
  }

  return EMO
})(jQuery)

jQuery(window).on('load', function () {
  window.emoController = new EMO()
  window.emoController.init()

  // Check for anchor in URL and open modal if it matches
  const hash = window.location.hash
  if (hash && hash.indexOf('#emo-open-') === 0) {
    const slug = hash.replace('#emo-open-', '')
    const $emo = jQuery('[data-emo="' + slug + '"]')
    if ($emo.length) {
      window.emoController.open($emo)
    }
  }
})